export default {
  name: 'HighlightMixin',
  props: {},
  data() {
    return {
      hasHighlight: false
    };
  },
  computed: {},
  watch: {
    hasHighlight: function (newVal) {
      if (newVal) {
        $('body').addClass('has-highlight');
      } else {
        $('body').removeClass('has-highlight');
      }
    }
  },
  methods: {
    checkHighlight() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const highlight = urlParams.get('highlight');

      if (highlight === null) {
        return false;
      }

      window.history.replaceState({}, document.title, location.pathname);

      this.hasHighlight = true;
      return true;
    },
  },
  mounted() {
    this.checkHighlight();
  },
};
